import { CalcoloInteressiRequest } from '../../../models/calcolo-interessi-request';

export class CalcoloInteressiRequestAdapter {

  calcoloInteressiRequest: CalcoloInteressiRequest = new CalcoloInteressiRequest();

  constructor(calcoloInteressiRequest: CalcoloInteressiRequest) {
    this.calcoloInteressiRequest.dataInizioCalcolo = calcoloInteressiRequest.dataInizioCalcolo;
    this.calcoloInteressiRequest.dataFineCalcolo = calcoloInteressiRequest.dataFineCalcolo;
    this.calcoloInteressiRequest.valore = calcoloInteressiRequest.valore;
    this.calcoloInteressiRequest.fineCalcoloAdUltimoGiornoMese = calcoloInteressiRequest.fineCalcoloAdUltimoGiornoMese ? calcoloInteressiRequest.fineCalcoloAdUltimoGiornoMese : false ;
    this.calcoloInteressiRequest.capitalizzazione = calcoloInteressiRequest.capitalizzazione ? calcoloInteressiRequest.capitalizzazione : false ;
  }
}
